export const LABEL_COLOR_COUNT = '#4A76B6';
export const ABS_BONDSCREENER_BTN_FILTERS_KEYS = [
  'includedStatusIds',
  'includedRegionIds',
  'includedCountryIds',
  'includedCurrencyIds',
  'includedSubsectorIds',
  'includedSubindustryIds',
  'includedRankingIds',
  'includedIssuerIds',
  'includedParentIds',
  'trancheSizeRange',
  'walRange',
  'includedRatingGroupIds',
  'includedRatingAgencyIds',
  'pricingSpreadRange',
  'couponRange',
  'tenorRange',
  'yieldRange',
  'maturityDateRange',
  'includedCouponTypeIds',
  'includedRegistrationGroupIds',
  'includedBenchmarkGroupIds',
  'dates',
];
export const PAGE_TITLE = 'Bond Screener';

export const bondScreenerNoAccessFeatures = [
  'Effortlessly compare pricing details of bonds, including tranche-level information',
  'Discover new bonds that align with your objectives and risk profiles',
  'Save time with dozens of filter parameters including Sector, Ratings, WAL, and coupon',
];

export const bondScreenerNoAccessDescription = 'Perform relative value analysis across tens of thousands of new issue bonds leveraging Finsight’s extensive datasets.';

export const bondScreenerImageCaption = 'Search and filter through 100,000+ bonds linked to deal profiles.';
